import React from "react";
import PropTypes from "prop-types";

import { Button } from "@gcs/design-system/react";

import * as S from "./HireSection.style";

const HireSection = ({
  title,
  description,
  btnLabel,
  image,
  altImage,
  onClickBtn,
}) => {
  return (
    <S.HireSectionContainer>
      <S.HireSectionContent className="container">
        {image ? (
          <S.HireSectionImage
            src={image}
            alt={altImage}
            width="384px"
            height="384px"
          />
        ) : null}

        <S.HireSectionBlock $largeGap={onClickBtn}>
          <S.HireSectionBlockTitle>{title}</S.HireSectionBlockTitle>

          <S.HireSectionBlockDescription>
            {description}
          </S.HireSectionBlockDescription>

          {onClickBtn ? (
            <Button type="button" variant="outlined-white" onClick={onClickBtn}>
              {btnLabel}
            </Button>
          ) : null}
        </S.HireSectionBlock>
      </S.HireSectionContent>
    </S.HireSectionContainer>
  );
};

HireSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.element,
  altImage: PropTypes.string,
  btnLabel: PropTypes.string,
  onClickBtn: PropTypes.func,
};

HireSection.defaultProps = {
  title: "Como contratar?",
  image: "",
  altImage: "",
  btnLabel: "Encontre uma agência",
  onClickBtn: null,
  description: (
    <>
      Visite sua agência Caixa e peça pelo Seguro Fácil Empresarial Empreendedor
      da Caixa Seguradora. O gerente vai te ajudar a escolher o combo mais
      adequado para a realidade do seu negócio.
    </>
  ),
};

export default HireSection;
